(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fab-flooring-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fab-flooring-calculator')) {
    customElements.define(
      'fab-flooring-calculator',
      class FabFlooringCalculator extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.squareFeetInput = this.querySelector('[data-square-feet]');
          this.result = this.querySelector('[data-result]');
          this.quantityInput = this.closest('product-info')?.querySelector('input[name="quantity"]');
          this.selectedVariantId = this.dataset.selectedVariantId;
          this.squareFeetInput.addEventListener('input', () => this.calculate());
          this.quantityInput?.addEventListener('change', () => this.updateFromQuantity());
          this.variantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange.bind(this)
          );
          this.renderVariantDetails();
        }

        disconnectedCallback() {
          this.variantChangeUnsubscriber?.();
        }

        get currentVariant() {
          return this.variants[this.selectedVariantId];
        }

        formatMoney(cents) {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: this.dataset.currency,
          }).format(cents / 100);
        }

        handleVariantChange({ data: { sectionId, variant } }) {
          if (String(sectionId) !== String(this.dataset.sectionId) || !variant?.id) return;
          this.selectedVariantId = String(variant.id);
          this.renderVariantDetails();
          if (this.squareFeetInput.value) {
            this.calculate();
          } else {
            this.result.hidden = true;
          }
        }

        renderVariantDetails() {
          const variant = this.currentVariant;
          if (!variant || Number(variant.coverage) <= 0) return;
          const coverage = Number(variant.coverage);
          this.querySelector('[data-coverage]').textContent = coverage.toFixed(2).replace(/\.00$/, '');
          this.querySelector('[data-box-price]').textContent = this.formatMoney(Number(variant.price));
          this.querySelector('[data-sqft-price]').textContent = this.formatMoney(Number(variant.price) / coverage);
        }

        calculate() {
          const variant = this.currentVariant;
          const requested = Number(this.squareFeetInput.value);
          const coverage = Number(variant?.coverage);
          if (!requested || requested <= 0 || !coverage || coverage <= 0) {
            this.result.hidden = true;
            return;
          }

          const boxes = Math.ceil(requested / coverage);
          if (this.quantityInput) {
            this.quantityInput.value = boxes;
            this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          this.renderResult(boxes, coverage, Number(variant.price));
        }

        updateFromQuantity() {
          const variant = this.currentVariant;
          const boxes = Number(this.quantityInput?.value);
          const coverage = Number(variant?.coverage);
          if (!boxes || !coverage) return;
          this.renderResult(boxes, coverage, Number(variant.price));
        }

        renderResult(boxes, coverage, price) {
          this.querySelector('[data-boxes]').textContent = boxes;
          this.querySelector('[data-boxes-label]').textContent = boxes === 1
            ? this.dataset.boxLabel
            : this.dataset.boxesLabel;
          this.querySelector('[data-total-coverage]').textContent = (boxes * coverage).toFixed(2).replace(/\.00$/, '');
          this.querySelector('[data-total-price]').textContent = this.formatMoney(boxes * price);
          this.result.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
